import axios from "axios";
import BackendClient from "../../BackendClient";
import CommonResponse from "../../models/CommonResponse";

export function sendNotificationToPlayer(client: BackendClient, bohId: string, title: string, bodyText: string, icon: string, color: string, duration: number): Promise<CommonResponse> {
    const headers = {
      'Authorization': `${client.getAuthEntity()} ${client.getAuthToken()}`,
    };

    return new Promise<CommonResponse>((resolve, reject) => {
    axios.post(`${client.getBackendUrl()}${BackendClient.SendNotificationToPlayer}`, {bohId: bohId, title: title, bodyText: bodyText, icon: icon, color: color, duration: duration}, {headers: headers})
      .then((response) => resolve(response.data))
      .catch((reason) => {
        console.log(`Exception when trying to send notification to player: ${JSON.stringify(reason)}`)
        reject(reason);
      });
  });
  }